import { isImageFile } from '@/utils/fileType'
export function _parse(str) {
  const isJSONString = str.indexOf('{') === 0
  if (isJSONString) {
    return JSON.parse(str)
  }
  return str
}

export function parse(str) {
  let tag = '&em#'
  if (str && str.includes('&amp;em#')) {
    tag = '&amp;em#'
  }
  // 新增对 &json# 的兼容
  if (str && str.includes('&json#')) {
    tag = '&json#'
  }
  return str
    ?.split(tag)
    ?.filter(_ => _ !== '')
    .map(_parse)
}

export function isImage(data) {
  return data.type === 1 || isImageFile(data)
}

export function isSpacing(data) {
  return data.type === 2
}

export function isIcon(data) {
  return data.type === 3
}

export function isText(data) {
  return typeof data !== 'string' && data.type === undefined
}

export function isNormalText(data) {
  return typeof data === 'string'
}

export default {
  parse,
  isText,
  isSpacing,
  isImage,
  isIcon,
  isNormalText,
}
